module.exports = __webpack_public_path__ + "img/WATER_POLO.f0ad0cd0.png";